import { render, staticRenderFns } from "./HasManyCrud.vue?vue&type=template&id=60a7d836&"
import script from "./HasManyCrud.vue?vue&type=script&lang=js&"
export * from "./HasManyCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HasManyCrud.vue"
export default component.exports